var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1B",
  fillRule: "evenodd",
  d: "m36.43 16 14.55 9.33h5.35l5 5.4v10.6h-4V32.3l-2.75-2.97H15.22l-3.27-5.14-5.28 3.27v13.87h-4v-16.1L17.56 16zm-20.68 5.83 2.08 3.5h6.73V20H18.7zm27.82 3.5H28.56V20h6.7zM10 40a6 6 0 1 1 12 0 6 6 0 0 1-12 0m8 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0m30-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-9.33-.67H25.33v4h13.34z",
  clipRule: "evenodd"
})));
export { SvgCar as ReactComponent };
export default new URL("/home/runner/_work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/ulez/car.svg", import.meta.url).toString();